import { createComponent } from '@mtfe/sweet';
import { eventBus } from '@mtfe/sweet-utils';

import tpl from './dom.html';
import style from './style.less';

import V1 from './subModules/V1/script';
import V2 from './subModules/V2/script';
import V3 from './subModules/V3/script';
import store from '../../store';

const { storeCommon } = store;

const V1Module = {
    module: V1,
    ready: () => {
        eventBus.$emit('V1Ready');
    },
};
const V2Module = {
    module: V2,
    ready: () => {
        eventBus.$emit('V2Ready');
    },
};
const V3Module = {
    module: V3,
    ready: () => {
        eventBus.$emit('V3Ready');
    },
};

export const isShowShangouModules = () => {
    const { sgPageVersionId } = storeCommon.structInfo.expInfo;
    const {
        // 闪购每日优惠
        dom_sg_every_day_coupon: domSgEveryDayCoupon,
        // 不带sku的红包
        dom_sg_cps_unbind_coupon: domSgLargeRedBag,
        // 用于请求带下挂菜的商家列表
        dom_sg_cps_unbind_coupon_sku: domSgSkuCoupon,
        // 请求闪购v3中的红包1
        dom_sg_cps_unbind_multi_poi_1: domSgMultiPoi1,
        // 请求闪购v3中的红包2
        dom_sg_cps_unbind_multi_poi_2: domSgMultiPoi2,
        // 请求闪购v3中的红包3
        dom_sg_cps_unbind_multi_poi_3: domSgMultiPoi3,
    } = storeCommon.structInfo.struct;

    const storeSgEveryDayCoupon = store[domSgEveryDayCoupon.recallBizId];
    const storeSgLargeRedBag = domSgLargeRedBag
        ? store[domSgLargeRedBag.recallBizId]
        : {};
    const storeSgSkuCoupon = domSgSkuCoupon
        ? store[domSgSkuCoupon.recallBizId]
        : {};

    const storeSgMultiPoi1 = domSgMultiPoi1
        ? store[domSgMultiPoi1.recallBizId]
        : {};
    const storeSgMultiPoi2 = domSgMultiPoi2
        ? store[domSgMultiPoi2.recallBizId]
        : {};
    const storeSgMultiPoi3 = domSgMultiPoi3
        ? store[domSgMultiPoi3.recallBizId]
        : {};

    if (sgPageVersionId === 'sgUnbindCouponWithPoiV1') {
        if (storeSgEveryDayCoupon.isShow || storeSgLargeRedBag.isShow) {
            return true;
        }
    } else if (sgPageVersionId === 'sgUnbindCouponWithPoiV2') {
        if (storeSgEveryDayCoupon.isShow || storeSgSkuCoupon.isShow) {
            return true;
        }
    } else if (sgPageVersionId === 'sgUnbindCouponWithPoiV3') {
        if (
            storeSgEveryDayCoupon.isShow ||
            storeSgMultiPoi1.isShow ||
            storeSgMultiPoi2.isShow ||
            storeSgMultiPoi3.isShow
        ) {
            return true;
        }
    } else {
        // 如果没有闪购版本相关配置，默认走v1
        if (storeSgEveryDayCoupon.isShow || storeSgLargeRedBag.isShow) {
            return true;
        }
    }
    return false;
};
/**
 * 判断是否展示闪购模块以及展示哪个闪购模块
 * @returns
 */
const selectRenderModule = () => {
    const { sgPageVersionId } = storeCommon.structInfo.expInfo;

    const renderMap = {
        V1Module,
        V2Module,
        V3Module,
        default: V1Module,
    };

    if (sgPageVersionId === 'sgUnbindCouponWithPoiV1') {
        return renderMap.V1Module;
    } else if (sgPageVersionId === 'sgUnbindCouponWithPoiV2') {
        return renderMap.V2Module;
    } else if (sgPageVersionId === 'sgUnbindCouponWithPoiV3') {
        return renderMap.V3Module;
    } else {
        return renderMap.default;
    }
};

const ShangouModulesReady = (renderModule) => {
    eventBus.$onceOn('ShangouModulesReady', () => {
        renderModule.ready();
    });
};

const ShangouModules = () => {
    const renderModule = selectRenderModule();
    const data = {
        renderModule: renderModule.module(),
    };
    const events = {};
    ShangouModulesReady(renderModule);
    return createComponent(tpl, { style, data }, events);
};

export default ShangouModules;
